// src/Container.tsx
import Box from "@mui/material/Box/index.js";
import { jsx } from "react/jsx-runtime";
var Container = ({ children, ...rest }) => /* @__PURE__ */ jsx(
  Box,
  {
    maxWidth: { xs: "100%", lg: 1800 },
    width: 1,
    margin: "0 auto",
    paddingX: { xs: 2, sm: 3 },
    paddingY: { xs: 4, sm: 6, md: 8 },
    ...rest,
    children
  }
);

export {
  Container
};
